// extracted by mini-css-extract-plugin
export default {"root":"ClientsHeading_root__58csq","title":"ClientsHeading_title__fNyXb"};